import api from './api';

const state = {
	APIKeys: [],
	loading: false,
	error: false,
	message: '',
	success: false,
	permissions: [],
	limit: 10,
	page: 0,
	foundAll: false,
};

const getters = {};

const mutations = {
	startLoading(state) {
		state.loading = true;
	},
	stopLoading(state) {
		state.loading = false;
	},
	setAPIKeys(state, { APIKeys }) {
		state.APIKeys = state.APIKeys.concat(APIKeys);
	},
	reset(state) {
		state.page = 0;
		state.APIKeys = [];
		state.foundAll = false;
	},
	setPermissions(state, { permissions }) {
		state.permissions = permissions;
	},
	updateDeletedState(state, { APIKey, showDeleted }) {
		const idx = state.APIKeys.findIndex((key) => key.id == APIKey.id);
		state.APIKeys[idx].deleted = !state.APIKeys[idx].deleted;
		if (state.APIKeys[idx].deleted && showDeleted == false) {
			state.APIKeys.splice(idx, 1);
		}
	},
	updateAPIKeyPermissions(state, { apiKey }) {
		const idx = state.APIKeys.findIndex((key) => key.id == apiKey.id);
		const perms = state.permissions.filter((permission) => apiKey.permissions.includes(permission));
		state.APIKeys[idx].permissions = perms;
		state.APIKeys[idx].comment = apiKey.comment;
	},
	showError(state, { message }) {
		state.error = true;
		state.message = message;
	},
	hideError(state) {
		state.error = false;
	},
	showSuccess(state) {
		state.success = true;
	},
	hideSuccess(state) {
		state.success = false;
	},
	updateOffset(state) {
		state.page += 1;
	},
	foundAll(state) {
		state.foundAll += true;
	},
};

const actions = {
	load({ state, commit, dispatch, rootGetters }, { showDeleted, limit, offset }) {
		commit('updateOffset');
		commit('startLoading');
		return api
			.load(showDeleted, limit, offset)
			.then(async (response) => {
				const APIKeys = response.data;
				await APIKeys.forEach((apiKey) => {
					apiKey.permissionIds = [];
					dispatch('getAPIKeyPermissions', apiKey.id).then((permissions) => {
						apiKey.permissions = permissions;
					});
				});
				commit('setAPIKeys', { APIKeys });
				commit('stopLoading');
				return APIKeys;
			})
			.catch((err) => {
				console.log(err.response);
				const message = err.response.data.message;
				commit('showError', { message });
				commit('stopLoading');
			});
	},

	getAPIKey({ state, commit, dispatch, rootGetters }, id) {
		commit('startLoading');
		return api
			.getAPIKey(id)
			.then((response) => {
				const APIKey = response.data;
				commit('stopLoading');
				return APIKey;
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showError', { message });
				commit('stopLoading');
			});
	},

	createAPIKey({ dispatch, commit }, newAPIKey) {
		commit('startLoading');
		return api
			.createAPIKey(newAPIKey.comment)
			.then(async (res) => {
				const id = res.data.id;
				const password = res.data.password;
				await api.updateAPIKeyPermissions(newAPIKey.permissions, id);
				commit('stopLoading');
				return password;
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showError', { message });
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				return message;
			});
	},

	editAPIKey({ state, commit }, { apiKey }) {
		commit('startLoading');
		return api
			.editAPIKey(apiKey)
			.then(async () => {
				await api.updateAPIKeyPermissions(apiKey.permissions, apiKey.id);
				commit('updateAPIKeyPermissions', { apiKey });
				commit('showSuccess');
				commit('stopLoading');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
			})
			.catch((err) => {
				const message = err.response.message;
				commit('showError', { message });
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				return message;
			});
	},

	async deleteAPIKey({ state, commit, rootGetters, dispatch }, { APIKey, showDeleted }) {
		var result;
		if (!APIKey.deleted) {
			result = api.deleteAPIKey(APIKey);
		} else {
			const copy = { ...APIKey };
			copy.deleted = false;
			result = api.editAPIKey(copy);
		}
		return result
			.then(() => {
				commit('showSuccess');
				commit('updateDeletedState', { APIKey, showDeleted });
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
			})
			.catch((err) => {
				console.log(err);
				const message = err.response.data.message;
				commit('showError', { message });
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				return message;
			});
	},

	loadPermissions({ state, commit, rootGetters }) {
		commit('startLoading');
		return api
			.loadPermissions()
			.then((response) => {
				const permissions = response.data;
				commit('setPermissions', { permissions });
				commit('stopLoading');
				return permissions;
			})
			.catch((err) => {
				const message = err.data.message;
				commit('showError', { message });
				commit('stopLoading');
			});
	},

	getAPIKeyPermissions({ state, commit, rootGetters }, id) {
		commit('startLoading');
		return api
			.getAPIKeyPermissions(id)
			.then((response) => {
				const permissions = response.data;
				commit('stopLoading');
				return permissions.map(permission => { return permission.key; });
			})
			.catch((err) => {
				const message = err.data.message;
				commit('showError', { message });
				commit('stopLoading');
			});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
